








































































import {
  Component, Prop, Mixins, Watch,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import { FieldComponent, FormFieldElement } from '@/types/FieldComponent';
import { VForm } from '@/types/FormComponent';
import FieldComponentsFormData from '@/mixins/FieldComponentsFormData';
import PreviewForm from '@/components/FormBuilder/PreviewForm.vue';
import { findFieldComponent, normalizeData, normalizePreviewData } from '@/utils/form';
import LayoutMixin from '@/mixins/LayoutMixin';
import {
  USES_NDS_FIELD, PERCENT_NDS_FIELD, isNdsEnabled, percentNdsRule, hasPercentNdsValue,
} from '@/utils/supplierNds';

@Component({
  components: { PreviewForm },
})
export default class DynamicForm extends Mixins(FieldComponentsFormData, LayoutMixin) {
  editedFields: string[] = [];

  previewData: Record<string, any> | null = null;

  @Prop({ default: 0 })
  readonly loadingItems!: number;

  @Prop({ default: false })
  readonly formDisabled!: boolean;

  @State('isModalVisible', { namespace: 'entity' })
  isModalVisible!: boolean;

  get isLoading() {
    return this.loadingItems && !this.fieldComponents.length;
  }

  get factoryForm(): VForm {
    return this.$refs.factoryForm as VForm;
  }

  get formLayoutFieldComponents(): FormFieldElement[] {
    return this.formLayoutFields
      .map((layoutElement) => findFieldComponent(layoutElement, this.fieldComponents))
      .filter((field: FormFieldElement) => field.fieldComponent?.component);
  }

  pushEditedField(fieldName: string) {
    this.editedFields.push(fieldName);
    this.$emit('edit-field');
  }

  /**
   * Гейтинг percentNDS по usesNDS (8045). No-op, пока percentNDS/usesNDS нет в схеме.
   */
  get percentNdsComponent(): FieldComponent | undefined {
    return this.fieldComponents?.find((f: FieldComponent) => f.name === PERCENT_NDS_FIELD);
  }

  get hasNdsGating(): boolean {
    return Boolean(
      this.percentNdsComponent
      && this.fieldComponents?.some((f: FieldComponent) => f.name === USES_NDS_FIELD),
    );
  }

  /**
   * @param markEdited true — сброс percentNDS вызван действием пользователя
   * (переключение usesNDS в «нет»): сброшенное значение должно уйти в editedFields.
   */
  applyNdsGating(markEdited: boolean) {
    if (!this.hasNdsGating) return;
    const field = this.percentNdsComponent as FieldComponent;
    const enabled = isNdsEnabled(this.formData[USES_NDS_FIELD]);
    this.$set(field.props, 'rules', [percentNdsRule]);
    this.$set(field.props, 'disabled', !enabled);
    if (!enabled && hasPercentNdsValue(this.formData[PERCENT_NDS_FIELD])) {
      this.$set(this.formData, PERCENT_NDS_FIELD, null);
      if (markEdited) this.onChange(field);
    }
  }

  @Watch('fieldComponents')
  onFieldComponentsChangeNds() {
    // Ватчер миксина FieldComponentsFormData (bindFormDataValues) отработал раньше —
    // formData уже перепривязана; применяем начальное состояние без пометки edited.
    this.applyNdsGating(false);
  }

  async submit() {
    if (this.hasNdsGating && this.factoryForm && !this.factoryForm.validate()) return;
    const normalizedFormData = await this.normalizeDataBeforeSubmit();

    this.$emit('submit', normalizedFormData);
  }

  togglePreview() {
    if (this.previewData) {
      this.hidePreview();
    } else {
      this.previewEntity();
    }
  }

  async previewEntity() {
    this.previewData = await this.normalizeDateBeforePreview();
    this.$bus.$emit('preview', Boolean(this.previewData));
  }

  hidePreview() {
    this.previewData = null;
    this.$bus.$emit('preview', null);
  }

  async normalizeDataBeforeSubmit() {
    const ndsDisabled = this.hasNdsGating && !isNdsEnabled(this.formData[USES_NDS_FIELD]);
    const entries = this.editedFields.map((key) => {
      const valueFromFormData = key === PERCENT_NDS_FIELD && ndsDisabled
        ? null
        : this.formData[key];
      return [key, valueFromFormData];
    });
    const editedFormData = Object.fromEntries(entries);
    const normalizedData = await normalizeData(editedFormData, this.fieldComponents);
    return normalizedData;
  }

  async normalizeDateBeforePreview() {
    return normalizePreviewData(this.formData, this.fieldComponents);
  }

  @Watch('isModalVisible')
  onModalStateChange(value: boolean) {
    if (!value) {
      this.factoryForm.reset();
      this.editedFields = [];
      this.hidePreview();
    }
  }

  onChange(field: FieldComponent) {
    if (!this.editedFields.includes(field.name)) this.pushEditedField(field.name);
    if (field.name === USES_NDS_FIELD) {
      // v-model мог ещё не обновить formData — гейтим на следующем тике
      this.$nextTick(() => this.applyNdsGating(true));
    }
  }
}
